<template>
  <div class="board">
    <div class="board-title">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style scoped>
.board { background: rgba(255, 255, 255, .05); }
.board-title { border-bottom: 1px solid #263238; height: 40px; line-height: 40px; padding: 0 12px; text-align: center; }
</style>



// WEBPACK FOOTER //
// src/components/MBoard.vue